import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { fetchProperties, saveProperty, deleteProperty, updateProperty } from '../../store/actions/properties';
import { selectProperties } from '../../store/selectors/properties';
import Heading from '../../components/Heading';
import PropertiesTable from '../../components/PropertiesTable';
import Tabs from '../../components/Tabs';
import WithNavigation from '../../layouts/WithNavigation';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search';
import { upload } from '../../helpers/upLoadHelper'
import { clearServiceRequests } from '../../store/actions/serviceRequests';
import { selectServiceRequests} from '../../store/selectors/serviceRequests'
import { fetchSuiteAreas, clearSuites } from '../../store/actions/suites';
import { clearFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { fetchItems } from '../../store/actions/items';
import { selectItems } from '../../store/selectors/items';
import Loader from '../../components/Loader';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import { variables } from '../../Tenants';
import { fetchtTabList, clearSelectedModulePermission } from '../../store/actions/tabSelections';
import { stopLoaders } from '../../store/actions/loader';
import { clearActiveTab } from '../../store/actions/activeTab';

class Properties extends Component {
  componentDidMount() {
    const { onFetchProperties, clearSearch,clearServiceRequests, fetchSuiteAreas,clearSuites, clearFaqsNotesDocuments, fetchItems, items, user, fetchtTabList, clearSelectedModulePermission, stopLoaders } = this.props;
    stopLoaders(); 
    clearServiceRequests();
    clearSelectedModulePermission();
    clearSearch();
    clearSuites();
    clearFaqsNotesDocuments();
    fetchtTabList();
  //  onFetchProperties(JSON.parse(localStorage.getItem('user')).id);
   onFetchProperties(user.id, user.roles[0].role.name)
    fetchSuiteAreas();
    if(items.length === 0) {
      fetchItems();
    }
  }
  componentWillMount(){
    const {clearActiveTab}=this.props;
    clearActiveTab()
  }
  saveProperty = async (data) => {
    let params = {};

    let imageUrl = null
    if (data.selectedImage && data.selectedImage.length > 0) {
      imageUrl = await upload(data.selectedImage[0])
    }
 

    let stages = data.constructionStages && data.constructionStages.length > 0 ? data.constructionStages.filter(cs => !cs.new) : []      

    if (data.propertyId) {
      params = {
        "id": data.propertyId,
        "propertyId": data.propertyId,
        "name": data.name,
        "addressLine1": data.addressLine1,
        "addressLine2": '',
        "city": data.city,
        "province": data.province,
        "postalCode": data.postalCode,
        "latitude": "17.5896",
        "longitude": "17.556896",
        "image": imageUrl != null ? imageUrl : data.image,
        "UserId": this.props.user.id,
        "PropertyManagerId": data.propertyManager && data.propertyManager.id ? data.propertyManager.id : data.propertyManagerId,
        "StrataManagerId":data.strataManagerId ? data.strataManagerId : data.strataManager && data.strataManager.id ? data.strataManager.id : null,
        "ConstructionStages": stages,
        "modulePermissions":data.modulePermissions || []
      }
      this.props.onUpdateProperty(params)
    } else {
      params = {
        "Name": data.name,
        "AddressLine1": data.addressLine1,
        "AddressLine2": "",
        "City": data.city,
        "Province": data.province,
        "PostalCode": data.postalCode,
        "Latitude": "17.5896",
        "Longitude": "17.556896",
        "Image": imageUrl,
        "UserId": this.props.user.id,
        "PropertyManagerId": data.propertyManagerId,
        "StrataManagerId":data.strataManagerId,
        "ConstructionStages": stages,
        "modulePermissions":data.modulePermissions || []
      }
      this.props.onSaveProperty(params);
    }
  }

  deleteProperty(data) {
    this.props.onDeleteProperty(data.id, this.props.user.id)
    this.setState({ state: this.state })
  }

  render() {
    const { properties, onFetchProperties, setSearch, loader, tabSelections, clearSelectedModulePermission } = this.props;
    let tabList=tabSelections.tabList;
    let suites = 0;
    let serviceRequests = 0;
    for (var i = 0; i < properties.length; i++) {
      suites = properties[i].suits + suites;
      serviceRequests = properties[i].serviceRequests + serviceRequests;
    }
    return (
      <WithNavigation
        title="Properties"
        top={(
          <Heading
            headline="Properties"
            items={[
              {
                key: 'Properties',
                value: properties.length,
              }, {
                key: variables.suites,
                value: suites,
              }, {
                key: 'Service Requests',
                value: serviceRequests,
              }
            ]}
          />
        )}
        bottom={
          loader ?
          <Loader center={true}/>
          :
          (
          <Tabs
            items={[
              {
                label: 'Properties',
                length: properties.length,
                content: (
                  <PropertiesTable
                    properties={properties}
                    onFetchProperties={onFetchProperties}
                    onSaveProperty={ (data) => this.saveProperty(data)}
                    onSearch={e => setSearch({ properties: e.target.value.trim() })}
                    onDeleteProperty={ (data) => this.deleteProperty(data)}
                    tabList={tabList}
                    clearSelectedModulePermission={clearSelectedModulePermission}
                  />
                ),
              }
            ]}
          />
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  properties: selectProperties(state),
  user: selectAuthenticatedUser(state),
  serviceRequests: selectServiceRequests(state),
  items: selectItems(state),
  loader: selectPRLoader(state),
  tabSelections:state.tabSelections,  
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchProperties: fetchProperties,
  onSaveProperty: saveProperty,
  onUpdateProperty: updateProperty,
  onDeleteProperty: deleteProperty,
  setSearch,
  clearSearch,
  clearServiceRequests,
  fetchSuiteAreas: fetchSuiteAreas,
  clearSuites,
  clearFaqsNotesDocuments,
  fetchItems,
  fetchtTabList:fetchtTabList,
  clearSelectedModulePermission:clearSelectedModulePermission,
  stopLoaders,
  clearActiveTab
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Properties);
